/*CATALOGUE*/
const Brands = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/catalogue/Brands.vue');
const Categories = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/catalogue/Categories.vue');

const Products = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/catalogue/Products.vue');
const Product = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/catalogue/product/Product.vue');
const ProductDetails = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/catalogue/product/Details.vue');
const ProductMeta = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/catalogue/product/Meta.vue');
const ProductStock = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/catalogue/product/Stock.vue');
const ProductCategories = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/catalogue/product/Categories.vue');
const ProductRelated = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/catalogue/product/Related.vue');
const ProductImages = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/catalogue/product/Images.vue');

export default [
  {
    path: 'catalogue',
    name: 'loyaltyvenue.store.catalogue',
    redirect: {name: 'loyaltyvenue.store.catalogue.products'},
    component: {
      props: ['store', 'store_id'],
      template: '<router-view :store=store :store_id=store_id />',
    },
    meta: {
      icon: 'book',
      trans: 'loyaltyvenue:general.titles.catalogue',
    },
    children: [
      {
        name: 'loyaltyvenue.store.catalogue.brands',
        path: 'brands',
        component: Brands,
        meta: {
          trans: 'loyaltyvenue:general.titles.brands',
          menu: true,
        },
      },
      {
        name: 'loyaltyvenue.store.catalogue.categories',
        path: 'categories',
        component: Categories,
        meta: {
          trans: 'loyaltyvenue:general.titles.categories',
          menu: true,
        },
      },
      {
        name: 'loyaltyvenue.store.catalogue.products',
        path: 'products',
        component: Products,
        meta: {
          trans: 'loyaltyvenue:general.titles.products',
          menu: true,
        },
      },
      {
        name: 'loyaltyvenue.store.catalogue.products.product',
        path: 'products/:id',
        props: true,
        component: Product,
        redirect: {name: 'loyaltyvenue.store.catalogue.products.product.details'},
        meta: {
          trans: 'loyaltyvenue:general.titles.products',
          up: 'loyaltyvenue.store.catalogue.products',
        },
        children: [
          {
            name: 'loyaltyvenue.store.catalogue.products.product.details',
            path: 'details',
            props: true,
            component: ProductDetails,
          },
          {
            name: 'loyaltyvenue.store.catalogue.products.product.meta',
            path: 'meta',
            props: true,
            component: ProductMeta,
          },
          {
            name: 'loyaltyvenue.store.catalogue.products.product.stock',
            path: 'stock',
            props: true,
            component: ProductStock,
          },
          {
            name: 'loyaltyvenue.store.catalogue.products.product.categories',
            path: 'categories',
            props: true,
            component: ProductCategories,
          },
          {
            name: 'loyaltyvenue.store.catalogue.products.product.related',
            path: 'related',
            props: true,
            component: ProductRelated,
          },
          {
            name: 'loyaltyvenue.store.catalogue.products.product.images',
            path: 'images',
            props: true,
            component: ProductImages,
          },
        ],
      },
    ],
  },
];


// WEBPACK FOOTER //
// ./src/apps/loyaltyvenue/routes_catalogue.js